
import http from '@/assets/api/http';

// 终止运费调控
export async function stopRegulate(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.rules.DeliveryFeeRegulateService.stopRegulate',params,'POST');
}

// 取消运费调控，使调控失效
export async function cancelRegulate(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.rules.DeliveryFeeRegulateService.invalidRegulate',params,'POST');
}